/**
 * Matches the browser's network-level fetch failures ("Failed to fetch" in
 * Chrome, "NetworkError when attempting to fetch a resource" in Firefox,
 * "Load failed" in Safari). These mean the API was unreachable — flaky
 * shop-floor Wi-Fi, captive portals, or an outage — not an application bug.
 */
export function isNetworkError(error: unknown): boolean {
  return (
    error instanceof TypeError &&
    /failed to fetch|networkerror when attempting|load failed/i.test(
      error.message
    )
  );
}
